<svg width="140" height="88" viewBox="0 0 140 88" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="139" height="86.3964" rx="3.5" fill="currentColor" stroke="#BBBFC3"/>
    <rect x="8" y="9.81982" width="38.6231" height="19.9617" rx="2.03279" fill="#BBBFC3"/>
    <rect x="8" y="33.3873" width="38.6231" height="19.9617" rx="2.03279" fill="#BBBFC3"/>
    <rect x="8" y="56.9551" width="38.6231" height="19.9617" rx="2.03279" fill="#BBBFC3"/>
    <rect x="50.6875" y="9.81982" width="38.6231" height="19.9617" rx="2.03279" fill="#BBBFC3"/>
    <rect x="50.6875" y="33.3873" width="38.6231" height="19.9617" rx="2.03279" fill="#BBBFC3"/>
    <rect x="50.6875" y="56.9551" width="38.6231" height="19.9617" rx="2.03279" fill="#BBBFC3"/>
    <rect x="92.3594" y="9.81982" width="39.6395" height="19.9617" rx="2.03279" fill="#BBBFC3"/>
    <rect x="92.3594" y="33.3873" width="39.6395" height="19.9617" rx="2.03279" fill="#BBBFC3"/>
    <rect x="92.3594" y="56.9551" width="39.6395" height="19.9617" rx="2.03279" fill="#BBBFC3"/>
</svg>
